import axios from 'axios'
import React, { Component, useEffect, useState } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { Spinner } from 'react-activity';
import { connect } from 'react-redux';
import Login from './components/login/Login';
import BasePage from "./components/BasePage";
import RegisterPage from "./components/register/RegisterPage";
import { getUserByInvite, getUserByPasswordReset } from "./requests/UserRequests";
import RegistrationRequestPage from "./components/register/RegistrationRequestPage";
import ResetPasswordPage from "./components/reset-password-page/ResetPasswordPage";
import ResetPasswordFinishPage from "./components/reset-password-page/ResetPasswordFinishPage";
import RouterListener from "./components/RouterListener";
import './components/layout/Layout.scss';
import { IntlProvider } from "react-intl";
import {
    ThemeProvider,
} from '@material-ui/core/styles';

//fontawesome
import { library as faLibrary } from '@fortawesome/fontawesome-svg-core'
import { faMoneyCheck } from '@fortawesome/free-solid-svg-icons'
import { getAppConfiguration } from "./requests/ConfigRequests";
import { setConfig } from "./reducers/AppReducer";
import DocumentTitle from "./DocumentTitle";
import AutoRegisterPage from "./components/register/auto-register/AutoRegisterPage";
import AutoRegisterConfirmInstructions from "./components/register/auto-register/AutoRegisterConfirmInstructions";
import AutoRegisterConfirm from "./components/register/auto-register/AutoRegisterConfirm";
import AutoRegisterAccounts from "./components/register/auto-register/AutoRegisterAccounts";
import AutoRegisterWaitingConfirmation from "./components/register/auto-register/AutoRegisterWaitingConfirmation";
import SystemError from "./components/SystemError";
import SiteErrorBoundary from "./error-boundaries/SiteErrorBoundary";
import { AuthStatus } from "./interfaces/AuthStatus";
import { setAuthStatus } from "./actions/UserActions";
import { setToken } from "./fetch";
import { defaultTheme } from "./theme/default";
import { useParams } from "react-router-dom";
import { isStringNotEmptyOrNull } from "./utils";
import { clearSessionStorage } from "./reducers/RootReducer";

faLibrary.add(faMoneyCheck);


interface LanguageMessages {
    [language: string]: { [key: string]: string }
}

function buildMessages(allMessages: LanguageMessages, language: string, country: string) {
    let messages: { [key: string]: string } = {};
    if (language == "") {
        language = "en";
    }
    let defaultMessages = allMessages["xx"] ?? {};
    messages = Object.assign(messages, defaultMessages);
    let languageMessages = allMessages[language] ?? {};
    messages = Object.assign(messages, languageMessages);
    if (country !== "") {
        let countryMessages = allMessages["xx-" + country] ?? {};
        messages = Object.assign(messages, countryMessages);
        let languageCountryMessages = allMessages[language + "-" + country] ?? {};
        messages = Object.assign(messages, languageCountryMessages);
    } else {
        let countryMessages = allMessages["xx-" + country] ?? {};
        messages = Object.assign(messages, countryMessages);
    }
    return messages;
}

function App(props) {
    console.log(props)
    useEffect(() => {
        let configPromise = getAppConfiguration();
        let loginStatusPromise = axios.get<{
            status: string; isLoggedIn: boolean, token: string, refreshToken: string
        }>("/api/login-status");
        Promise.all([configPromise, loginStatusPromise]).then((results) => {
            // Order matters here.
            if (results[1].data.status === "waiting-confirmation") {
                return;
            }
            
            props.setConfig(results[0]);

            if (results[1].data.isLoggedIn) {
                if (results[1].data.token) {
                    clearSessionStorage();
                    setToken(results[1].data.token, results[1].data.refreshToken);
                }
                props.setAuthStatus(AuthStatus.Authenticated);
            } else {
                props.setAuthStatus(AuthStatus.Unauthenticated);
            }
        });
    }, []);


    function getLanguageMessages() {
        let messages = {};
        if (typeof props.config.languages !== "undefined") {
            messages = buildMessages(props.config.languages, props.language, props.country);
        }
        return messages;
    }

    let messages = getLanguageMessages();

    return (
        <SiteErrorBoundary>
            <ThemeProvider theme={defaultTheme}>

                <IntlProvider locale={props.language} messages={messages}>
                    <BrowserRouter>
                        <div>
                            <RouterListener />
                            <ToastContainer />
                            <Spinner animating={props.animating > 0} size={50} className="centered" />
                            {props.loginChecked && <DocumentTitle />}
                            {
                                (() => {
                                    switch (props.authStatus) {
                                        case AuthStatus.Waiting:
                                            return <div />;
                                        case AuthStatus.Authenticated:
                                            return <Switch>
                                                <Route path="/" component={BasePage} />
                                            </Switch>;
                                        case AuthStatus.Failed:
                                        case AuthStatus.TimedOut:
                                        case AuthStatus.LoggedOut:
                                        case AuthStatus.Unauthenticated:
                                            return <Switch>
                                                <Route path={"/login"} component={Login} />
                                                {/*<Route path="/register/:token" render={props =>*/}
                                                {/*    <RegisterPage invite={props.match.params.token}*/}
                                                {/*                  getUserByInvite={getUserByInvite}/>*/}
                                                {/*}/>*/}
                                                <Route path="/system-error" render={props =>
                                                    <SystemError />
                                                } />
                                                {/*<Route path="/registration-request" render={props =>*/}
                                                {/*    <RegistrationRequestPage/>*/}
                                                {/*}/>*/}
                                                {/*<Route path="/auto-register/create" render={props =>*/}
                                                {/*    <AutoRegisterPage/>*/}
                                                {/*}/>*/}
                                                <Route path="/request-password-reset" render={props =>
                                                    <ResetPasswordPage />
                                                } />
                                                <Route path="/reset-password/:id" render={props =>
                                                    <ResetPasswordFinishPage
                                                        getUserByPasswordReset={getUserByPasswordReset}
                                                        passwordReset={props.match.params.id} />
                                                } />
                                                <Route path="/auto-register/confirm-instructions" render={props =>
                                                    <AutoRegisterConfirmInstructions />
                                                } />
                                                <Route path="/auto-register/confirm/:token" render={props =>
                                                    <AutoRegisterConfirm />
                                                } />
                                                <Route path="/auto-register/waiting-confirmation" render={props =>
                                                    <AutoRegisterWaitingConfirmation />
                                                } />
                                                <Route path="/auto-register/accounts" render={props =>
                                                    <AutoRegisterAccounts />
                                                } />
                                                {isStringNotEmptyOrNull(process.env.REACT_APP_SSO_REDIRECT_URL as string) &&
                                                    <Route path={"/"} render={props => {
                                                        window.location.href = process.env.REACT_APP_SSO_REDIRECT_URL as string;
                                                        return null;
                                                    }} />
                                                }
                                                {!isStringNotEmptyOrNull(process.env.REACT_APP_SSO_REDIRECT_URL as string) &&
                                                    <Route path={"/"} component={Login} />
                                                }
                                            </Switch>
                                    }
                                })()
                            }
                        </div>
                    </BrowserRouter>
                </IntlProvider>
            </ThemeProvider>
        </SiteErrorBoundary>
    );
}


export default connect<any, any, any, any>(state => ({
    animating: state.default.animating,
    authStatus: state.user.authStatus,
    language: state.user.language,
    country: state.user.country,
    config: state.app.config,
}), {
    setAuthStatus,
    setConfig,
})(App);
